import { render, staticRenderFns } from "./img-thumbnail.vue?vue&type=template&id=21acb5a0&scoped=true&"
import script from "./img-thumbnail.vue?vue&type=script&lang=ts&"
export * from "./img-thumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./img-thumbnail.vue?vue&type=style&index=0&id=21acb5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21acb5a0",
  null
  
)

export default component.exports